module.exports = {
  "addedCondition": {
    "properties": {
      "property": "string",
      "usedSemanticSearch": {
        "type": "boolean",
        "isOptional": true
      },
      "hadSemanticSearchResults": {
        "type": "boolean",
        "isOptional": true
      },
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    },
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction"
  },
  "editedCondition": {
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction",
    "properties": {
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    }
  },
  "deletedCondition": {
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction",
    "properties": {
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    }
  },
  "changedFilterType": {
    "properties": {
      "property": "string",
      "usedSemanticSearch": {
        "type": "boolean",
        "isOptional": true
      },
      "hadSemanticSearchResults": {
        "type": "boolean",
        "isOptional": true
      },
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    },
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction"
  },
  "changedFilterOperator": {
    "properties": {
      "operator": "string",
      "property": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    },
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction"
  },
  "addedFilterGroup": {
    "properties": {
      "type": [
        "AND"
      ],
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    },
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction"
  },
  "clonedFilterGroup": {
    "properties": {
      "type": [
        "AND"
      ],
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    },
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction"
  },
  "deletedFilterGroup": {
    "properties": {
      "type": [
        "AND"
      ],
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    },
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction"
  },
  "openedAdvancedFiltersPanel": {
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction",
    "properties": {
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    }
  },
  "closedAdvancedFiltersPanel": {
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction",
    "properties": {
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    }
  },
  "openedTestARecord": {
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction",
    "properties": {
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    }
  },
  "closedTestARecord": {
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction",
    "properties": {
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    }
  },
  "openedMultiValueEditor": {
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction",
    "properties": {
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    }
  },
  "usedDelimiterInMultiValueEditor": {
    "properties": {
      "value": "string",
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    },
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction"
  },
  "confirmedMultiValueEditor": {
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction",
    "properties": {
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    }
  },
  "canceledMultiValueEditor": {
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction",
    "properties": {
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    }
  },
  "changedObjectType": {
    "properties": {
      "objectType": "string",
      "type": [
        "current",
        "associated"
      ],
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    },
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction"
  },
  "clickedEditFilters": {
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction",
    "properties": {
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    }
  },
  "discardedChanges": {
    "namespace": "filters-fe",
    "name": "Segmentation Filters Interaction",
    "class": "interaction",
    "properties": {
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    }
  },
  "addedValue": {
    "properties": {
      "property": "string",
      "type": [
        "default",
        "custom"
      ],
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    },
    "namespace": "filters-fe",
    "name": "Quick Filters Interaction",
    "class": "interaction"
  },
  "editedValue": {
    "properties": {
      "property": "string",
      "type": [
        "default",
        "custom"
      ],
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    },
    "namespace": "filters-fe",
    "name": "Quick Filters Interaction",
    "class": "interaction"
  },
  "clearedValue": {
    "properties": {
      "property": "string",
      "type": [
        "default",
        "custom"
      ],
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    },
    "namespace": "filters-fe",
    "name": "Quick Filters Interaction",
    "class": "interaction"
  },
  "clearedAllValues": {
    "namespace": "filters-fe",
    "name": "Quick Filters Interaction",
    "class": "interaction",
    "properties": {
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    }
  },
  "addedProperty": {
    "properties": {
      "property": "string",
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    },
    "namespace": "filters-fe",
    "name": "Quick Filters Interaction",
    "class": "interaction"
  },
  "removedProperty": {
    "properties": {
      "property": "string",
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    },
    "namespace": "filters-fe",
    "name": "Quick Filters Interaction",
    "class": "interaction"
  },
  "reorderedProperty": {
    "properties": {
      "property": "string",
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    },
    "namespace": "filters-fe",
    "name": "Quick Filters Interaction",
    "class": "interaction"
  },
  "clickedAdvancedFilters": {
    "namespace": "filters-fe",
    "name": "Quick Filters Interaction",
    "class": "interaction",
    "properties": {
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    }
  },
  "clearedAdvancedFilters": {
    "namespace": "filters-fe",
    "name": "Quick Filters Interaction",
    "class": "interaction",
    "properties": {
      "primaryObjectTypeId": "string",
      "version": [
        "1",
        "2"
      ]
    }
  }
};